<!--Desktop Banner-->
<fgb-desktop-nav-banner [pageName]="'events.banner.title' | translate" [imageName]="'rewards'"></fgb-desktop-nav-banner>

<!--Mobile Navigation-->
<fgb-mobile-nav-menu [pageName]="'events.page.title' | translate"></fgb-mobile-nav-menu>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="bg-primary d-lg-none mobile-header-background"></div>
<div class="container mobile-page-content pt-4">
  <fgbcl-marketplace-list
    [isList]="true"
    [showSortBar]="false"
    [marketplaceItemTypes]="[3, 5]"
    [eventItemView]="true"
    [defaultSort]="2"
  ></fgbcl-marketplace-list>
</div>
